import { apiGetCustomers } from "@lib/api/customer";
import { createYupSync } from "@lib/helpers/TableHelper";
import { noteSchema as yupSchema } from "@lib/schemas/note";
import { Customer } from "@lib/types/Customer";
import { Note } from "@lib/types/Note";
import { useQuery } from "@tanstack/react-query";
import { Form, FormInstance, Input, Select, Typography } from "antd";
import { useEffect } from "react";
import useIntl from "react-intl/lib/src/components/useIntl";

type Props<T> = {
  form: FormInstance<T>;
  loading: boolean;
  note?: T;
  customer?: Customer;
};

export default function NoteCustomerInput<T extends Note>(props: Props<T>) {
  const { loading, note, customer, form } = props;
  const { messages } = useIntl();

  const isNotEditable = note || customer;

  const { data, isLoading } = useQuery({
    queryFn: () =>
      apiGetCustomers({
        page: 1,
        limit: 100,
        sort: "createdAt,DESC",
      }),
    queryKey: ["customers-dropdown"],
    enabled: !isNotEditable && !loading,
  });

  useEffect(() => {
    if (!form) return;
    if (isNotEditable) {
      form?.setFieldsValue({
        customerId: (note?.customer?.id || customer?.id) as any,
      });
    }
  }, [isNotEditable]);

  if (note && !note?.customer) return null;

  return (
    <Form.Item
      name="customerId"
      rules={[createYupSync({ schema: yupSchema })]}
      label={messages["common.customer"] as string}
    >
      {isNotEditable && (
        <>
          <Typography>
            {note?.customer?.name || customer?.name || ""}
          </Typography>
          <Input
            type="text"
            value={note?.customer?.name || customer?.name || ""}
            style={{ display: "none" }}
          />
        </>
      )}

      {!isNotEditable && (
        <Select
          placeholder={messages["common.makeYourChoice"] as string}
          disabled={loading || isLoading}
          showSearch
          optionFilterProp="text"
          options={data?.data?.data?.map((item) => ({
            label: item.name,
            text: item.name,
            value: item.id,
          }))}
        />
      )}
    </Form.Item>
  );
}
